<template>
    <div class="bento-container">
        <!-- Page Header -->
        <div class="bento-header">
            <div class="header-content">
                <div class="header-icon">
                    <i class="el-icon-key"></i>
                </div>
                <div class="header-text">
                    <h2>权限管理</h2>
                    <p>系统菜单配置 · 访问权限控制</p>
                </div>
            </div>
            <div class="header-actions">
                <div class="header-search">
                    <div class="search-input-wrapper">
                        <i class="el-icon-search input-icon"></i>
                        <el-input v-model="formDatas.authName" placeholder="搜索菜单名称" clearable size="medium"
                            class="ai-input" @keyup.enter.native="partserch"></el-input>
                    </div>
                </div>
                <el-button class="ai-btn" @click="partserch">
                    <i class="el-icon-search"></i>
                    搜索
                </el-button>
                <el-button class="ai-btn secondary" @click="resetSearch">
                    <i class="el-icon-refresh"></i>
                    重置
                </el-button>
                <el-button class="ai-btn secondary" @click="BoxOpen">
                    <i class="el-icon-plus"></i>
                    新增{{ level == 0 ? '目录' : level == 1 ? '菜单' : '按钮' }}
                </el-button>
            </div>
        </div>

        <!-- Bento Grid Layout -->
        <div class="bento-grid">
            <!-- Data Table Card - Full Width -->
            <div class="bento-card table-card full">
                <div class="card-header">
                    <span class="card-title">
                        <i class="el-icon-notebook-2"></i>
                        权限列表
                    </span>
                    <div class="card-actions">
                        <span class="ai-hint">
                            <i class="el-icon-info"></i>
                            层级：{{ level == 0 ? '目录' : level == 1 ? '菜单' : '按钮' }}
                        </span>
                    </div>
                </div>
                <div class="card-content">
                    <el-tabs v-model="editableTabsValue" type="card" :closable="level != 0" @edit="handleTabsEdit"
                        @tab-click="tabsClick" style="width: 100%;margin: 10px auto 0;">
                        <el-tab-pane :key="index" v-for="(item, index) in editableTabs" :label="item.title"
                            :name="item.name" style="width: 91%;"></el-tab-pane>
                    </el-tabs>
                    <div class="table-wrapper">
                        <div class="table-scroll-container">
                            <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                                :max-height="tableHight" :border-x="true" :border-y="true"
                                :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                                row-key-field-name="authId" :cellSelectionOption="cellSelectionOption"
                                style="width: 100%;" :editOption="editOption" />
                        </div>
                        <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                    </div>
                    <div class="table-pagination">
                        <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                            :page-size="formDatas.pageSize"
                            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                            @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Dialog -->
        <el-dialog :title="edit ? '编辑功能' : '新增功能'" :visible.sync="dialog" width="70%" top="8vh" class="ai-dialog">
            <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                <div class="dialog-form-content">
                    <el-form-item label="父级权限id" prop="authParentId">
                        <el-input v-model="form.authParentId" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单权限名称" prop="authName">
                        <el-input v-model="form.authName" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="地址" prop="authUrl">
                        <el-input v-model="form.authUrl" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="接口参数" prop="authParams">
                        <el-input v-model="form.authParams" type="textarea" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="描述" prop="authRemark">
                        <el-input v-model="form.authRemark" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="authOrder">
                        <el-input v-model="form.authOrder" type="number" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="图标" prop="authIcon">
                        <el-input v-model="form.authIcon" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="操作类型(0查询 1 新增 2编辑 3删除)" prop="authOperationType">
                        <el-input v-model="form.authOperationType" placeholder="请输入"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" class="ai-btn secondary">取消</el-button>
                <el-button type="primary" @click="SureBtn" class="ai-btn">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

import { getAjAuthList, addAjAuth, updateAjAuth, deleteAjAuth } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            postForm: {

            },
            authParentId: 0,
            editableTabsValue: '0',
            editableTabs: [{
                title: '目录',
                name: '0',
            }],
            tabIndex: 0,

            level: 0,
            key: 'authId',
            dialog: false,
            edit: false,
            form: {
                naName: '',
                authType: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",
                //     fixed: 'left',
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    fixed: 'left',
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "authName",
                    key: "authName",
                    fixed: 'left',
                    title: "菜单名称",
                    width: 180,
                    align: "center",
                },
                {
                    field: "authUrl",
                    key: "authUrl",
                    fixed: 'left',
                    title: "菜单地址",
                    align: "center",
                    width: 250,
                },
                {
                    field: "authRemark",
                    key: "authRemark",
                    title: "描述",
                    align: "center",
                     width: 150,
                },
                {
                    field: "authParams",
                    key: "authParams",
                    title: "接口参数",
                    align: "center",
                    width: 250,
                },

                {
                    field: "authOrder",
                    key: "authOrder",
                    title: "排序",
                    align: "center",
                    width: 100,
                },
                {
                    field: "authIcon",
                    key: "authIcon",
                    title: "图标",
                    align: "center",
                    width: 100,
                },
                {
                    field: "authOperationType",
                    key: "authOperationType",
                    title: "操作类型",
                    width: 200,
                    align: "center",

                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.authOperationType == 0 ? <span>查询</span> : row.authType == 1 ? <span>新增</span> : row.authType == 2 ? <span>编辑</span>
                                        : <span>删除</span>
                                }
                            </span>
                        );
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.authType == 0 && (row.authRemark && row.authRemark.indexOf('#', 0) == -1) ? <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.handleLevel(row)}
                                    >
                                        查看菜单
                                    </el-button> : row.authType == 1 || (row.authRemark && row.authRemark.indexOf('#', 0) > -1) ? <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.handleLevel(row)}
                                    >
                                        查看按钮
                                    </el-button> : <span></span>
                                }

                                {

                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDelete(row)}
                                    >
                                        删除
                                    </el-button>
                                }
                                {

                                    <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.handleEdit(row)}
                                    >
                                        编辑
                                    </el-button>
                                }
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                authType: 0,
                authParentId: 0,
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 260 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 260 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 260 - this.windheight * 0.04;
        this.getList();
        this.getPost('region')
    },
    mounted() { },
    methods: {
        getPost(key) {
            const userpost = JSON.parse(localStorage.getItem('userPost')) || [];
            userpost.forEach((item, index) => {
                if (item.nsaMenuKey == key) {
                    this.postForm[item.nsaFuncKey] = item.nsaFuncLabel
                }
            })
        },
        tabsClick(e) {
            console.log(e);
            this.editableTabsValue = e.name;
            this.tabIndex = this.editableTabsValue;
            this.level = this.tabIndex * 1;
            this.form.authParentId = this.editableTabs[e.index * 1].authParentId || 0;
            this.authParentId = this.editableTabs[e.index * 1].authParentId || 0;
            this.formDatas.authParentId = this.editableTabs[e.index * 1].authParentId || 0;
            this.partserch()
        },
        handleTabsEdit(targetName, action) {
            if (action === 'remove') {
                let tabs = this.editableTabs;
                let activeName = this.editableTabsValue;
                if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === targetName) {
                            let nextTab = tabs[index + 1] || tabs[index - 1];
                            if (nextTab) {
                                console.log('1', this.editableTabsValue);
                                activeName = nextTab.name;

                            }
                        }
                    });
                }

                this.editableTabsValue = activeName;
                const tabarr = this.editableTabs = tabs.filter(tab => tab.name !== targetName);
                console.log(this.editableTabs);
                this.tabIndex = tabarr[tabarr.length - 1].name;
                this.level = tabarr[tabarr.length - 1].name * 1;
                this.formDatas.authParentId = tabarr[tabarr.length - 1].authParentId || 0;
                this.partserch()
            }
        },
        handleLevel(row) {
            if (row.authRemark.indexOf('#', 0) > -1) {
                this.level = 2;
                console.log(this.level);
                this.tabIndex = this.editableTabsValue = 2 + '';
            } else {
                this.level = row.authType + 1;
                console.log(this.level);
                this.tabIndex = this.editableTabsValue = row.authType + 1 + '';
            }
            this.formDatas.authParentId = this.authParentId = row.authId;
            const s = {
                title: this.level == 1 ? '菜单' : '按钮',
                name: this.tabIndex,
                authParentId: row.authId
            }
            this.editableTabs.some((item, index) => {
                if (item.name === s.name) {

                    this.editableTabs.splice(index, 1, s)
                    console.log(this.editableTabs);
                    this.partserch();
                    return true
                } else if (index == this.editableTabs.length - 1 && item.name != s.name) {
                    this.editableTabs.push(s)
                    console.log(this.editableTabs);
                    this.partserch();
                }
            })


        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjAuth({ authId: row.authId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjAuth(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjAuth(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.form.authType = this.level;
            this.form.authParentId = this.authParentId;
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            // this.form.authParentId = this.authParentId = '';
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.authId = row.authId
                    console.log(jsonObj);
                    updateAjAuth(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjAuthList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.authType = this.level;
            this.formDatas.currentPage = 1;
            getAjAuthList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        resetSearch() {
            this.formDatas.authName = '';
            this.partserch();
        },
        getList() {
            getAjAuthList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style scoped>
/* Bento Grid Layout */
.bento-container {
    padding: 15px 20px;
    min-height: 100%;
    width: 100%;
    max-width: 100%;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    box-sizing: border-box;
    overflow: visible;
}

/* Page Header */
.bento-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding: 20px 24px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
}

.header-content {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
    border-radius: 12px;
    color: white;
    font-size: 24px;
}

.header-text h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1e293b;
}

.header-text p {
    margin: 4px 0 0;
    font-size: 13px;
    color: #64748b;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-search {
    flex: 1;
    max-width: 280px;
}

/* AI Button Styles */
.ai-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
    color: white;
    box-shadow: 0 4px 14px rgba(6, 182, 212, 0.4);
}

.ai-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(6, 182, 212, 0.5);
}

.ai-btn.secondary {
    background: white;
    color: #64748b;
    border: 1px solid #e2e8f0;
    box-shadow: none;
}

.ai-btn.secondary:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
}

/* Bento Grid */
.bento-grid {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    min-width: 0;
    overflow: visible;
}

/* Bento Card */
.bento-card {
    background: white;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    width: 100%;
    box-sizing: border-box;
    min-width: 0;
    overflow: visible;
}

.bento-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.bento-card.full {
    grid-column: span 1;
    width: 100%;
    max-width: 100%;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f1f5f9;
}

.card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
}

.card-title i {
    color: #06b6d4;
}

.ai-hint {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #94a3b8;
    padding: 4px 10px;
    background: #f8fafc;
    border-radius: 20px;
}

/* Search Input */
.search-input-wrapper {
    position: relative;
}

.input-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    z-index: 1;
}

.ai-input ::v-deep .el-input__inner {
    padding-left: 36px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    transition: all 0.3s;
}

.ai-input ::v-deep .el-input__inner:focus {
    border-color: #06b6d4;
    background: white;
    box-shadow: 0 0 0 3px rgba(6, 182, 212, 0.1);
}

/* Table Card */
.table-card {
    width: 100%;
    min-height: 400px;
}

.card-content {
    padding: 4px 0;
    width: 100%;
    overflow: visible;
}

.table-wrapper {
    width: 100%;
    overflow-x: auto;
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
}

.table-scroll-container {
    width: max-content;
    min-width: 100%;
}

.table-wrapper::-webkit-scrollbar {
    height: 8px;
    width: 8px;
}

.table-wrapper::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
}

.table-wrapper::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
}

.table-wrapper::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
}

/* ve-table internal overrides */
.table-wrapper ::v-deep .ve-table {
    min-width: max-content !important;
    table-layout: auto !important;
}

.table-wrapper ::v-deep .ve-table__body-container {
    overflow-x: auto !important;
    overflow-y: visible !important;
}

.table-wrapper ::v-deep .ve-table__header-container {
    overflow-x: auto !important;
    overflow-y: hidden !important;
}

.table-wrapper ::v-deep .ve-table-container {
    overflow-x: auto !important;
    overflow-y: visible !important;
    width: 100% !important;
    max-width: 100%;
}

.table-wrapper ::v-deep .ve-table__scroll-view {
    overflow-x: auto !important;
    overflow-y: visible !important;
}

.table-wrapper ::v-deep .ve-table__scroll-view--x {
    overflow-x: auto !important;
    overflow-y: visible !important;
}

.table-wrapper ::v-deep .ve-table__content {
    width: max-content !important;
    min-width: 100% !important;
}

/* Fallback class names (hyphenated) */
.table-wrapper ::v-deep .ve-table-container {
    overflow-x: auto !important;
    overflow-y: visible !important;
    width: 100% !important;
    max-width: 100%;
}

.table-wrapper ::v-deep .ve-table-scroll-view {
    overflow-x: auto !important;
    overflow-y: visible !important;
}

.table-wrapper ::v-deep .ve-table-body-x-scroll,
.table-wrapper ::v-deep .ve-table__body-x-scroll {
    overflow-x: auto !important;
    overflow-y: visible !important;
}

.table-wrapper ::v-deep .ve-table-header-x-scroll,
.table-wrapper ::v-deep .ve-table__header-x-scroll {
    overflow-x: auto !important;
    overflow-y: hidden !important;
}

.table-wrapper ::v-deep .ve-table-content {
    width: max-content !important;
}

/* Force table to respect container width */
.table-wrapper ::v-deep table.ve-table {
    width: max-content !important;
    max-width: max-content !important;
    table-layout: auto !important;
}

/* Ensure horizontal scroll works */
.table-wrapper ::v-deep .ve-table__header-x-scroll,
.table-wrapper ::v-deep .ve-table__body-x-scroll {
    max-width: 100%;
    overflow-x: auto !important;
}

/* Ensure wrapper allows horizontal scroll when needed */
.table-wrapper {
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: auto !important;
    display: block;
}

/* Dialog Styles */
.ai-dialog ::v-deep .el-dialog {
    border-radius: 16px;
}

.ai-dialog ::v-deep .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid #f1f5f9;
}

.dialog-form-content {
    /* display: grid; */
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    padding: 20px 0;
}

.dialog-form-content .el-form-item {
    margin-bottom: 0;
}

.dialog-form-content .el-input,
.dialog-form-content .el-textarea {
    width: 100%;
}

.dialog-form-content .el-input__inner,
.dialog-form-content .el-textarea__inner {
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
}

.dialog-form-content .el-input__inner:focus,
.dialog-form-content .el-textarea__inner:focus {
    border-color: #06b6d4;
    background: white;
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}

/* Responsive */
@media (max-width: 768px) {
    .bento-header {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }

    .header-actions {
        width: 100%;
        flex-wrap: wrap;
    }

    .header-search {
        max-width: 100%;
        flex: 1;
    }

    .dialog-form-content {
        grid-template-columns: 1fr;
    }
}
</style>